var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"APP"}},[(_vm.$route.meta.title === '웹 할인')?_c('div',[_c('router-view')],1):_c('div',{attrs:{"id":"wrap"}},[_c('gnb-area'),_c('div',{attrs:{"id":"containter"}},[_c('main-layout'),_c('footer-area')],1),(_vm.$route.name === 'main')?_c('main-map'):_vm._e()],1),_c('vue-confirm-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }